"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _statistics = require("@/api/statistics");
var _enums = require("./enums");
var _dayjs = _interopRequireDefault(require("dayjs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      nowDate: (0, _dayjs.default)().format('YYYY-MM-DD')
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '选择日期',
        prop: 'createTime',
        defaultValue: [this.nowDate, this.nowDate],
        type: 'dateRange',
        options: {
          startKey: 'startDate',
          endKey: 'endDate',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }, {
        label: '商品ID',
        prop: 'productId',
        defaultValue: '',
        type: 'input'
      }, {
        label: '来源',
        prop: 'userSource',
        defaultValue: '',
        type: 'select',
        options: {
          list: _enums.userSourceOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'statisticsDate',
        visible: true,
        label: "\u65E5\u671F",
        width: 140
      }, {
        key: 'userSource',
        visible: true,
        label: "\u94FE\u63A5\u6765\u6E90",
        formatter: 'text'
      }, {
        key: 'pv',
        visible: true,
        label: "PV",
        headerTip: '用户每打开或刷新一次页面即计数一次'
      }, {
        key: 'uv',
        visible: true,
        label: "UV",
        headerTip: '一个用户在当天24小时内多次访问标记为1'
      }, {
        key: 'orderCount',
        visible: true,
        label: "\u8BA2\u5355\u6570",
        headerTip: '用户支付成功记录一次（退款订单也包含在内）'
      }, {
        key: 'paidOrderCount',
        visible: true,
        label: "\u652F\u4ED8\u8BA2\u5355\u6570",
        headerTip: '用户支付成功记录一次（退款订单也包含在内）',
        width: 120
      }, {
        key: 'paidAmount',
        visible: true,
        label: "\u8BA2\u5355\u91D1\u989D",
        headerTip: '商品售价*支付订单数量（退款金额也包含在内）',
        formatter: 'text'
      }, {
        key: 'cost',
        visible: true,
        label: "\u5546\u54C1\u6210\u672C",
        headerTip: '商品成本*支付订单数量（退款成本也包含在内）',
        formatter: 'text'
      }, {
        key: 'refundAmount',
        visible: true,
        label: "\u9000\u6B3E\u91D1\u989D",
        headerTip: '商品售价*退款订单数量',
        formatter: 'text'
      }, {
        key: 'profit',
        visible: true,
        label: "\u5229\u6DA6",
        headerTip: '支付金额-成本',
        formatter: 'text'
      }
      // { key: 'status', visible: true, label: `状态`, width: 100, formatter: 'tag', formatOptions: { list: statusOptions } },
      ];
    }
  },
  methods: {
    getList: function getList(params) {
      return (0, _statistics.productOrderStatsApi)(params).then(function (data) {
        var list = (data.list || []).map(function (item) {
          return item;
        });
        return {
          list: list,
          total: +data.total
        };
      });
    },
    formatter: function formatter(key, value, type, scope) {
      if (key === 'userSource') {
        var defaultValue = type === 'text' ? value : '';
        var valueKey = type === 'text' ? 'label' : 'tag';
        var target = _enums.userSourceOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      return "\uFFE5".concat(value);
    },
    getSummaries: function getSummaries(maps) {
      var columns = maps.columns,
        data = maps.data;
      var sums = [];
      var idxMap = {
        pv: -1,
        uv: -1,
        orderCount: -1,
        paidOrderCount: -1,
        paidAmount: -1,
        cost: -1,
        refundAmount: -1,
        profit: -1,
        orderRate: -1,
        payRate: -1
      };
      var percentKeys = ['orderRate', 'payRate'];
      var amountKeys = ['paidAmount', 'cost', 'refundAmount', 'profit'];
      columns.forEach(function (column, index) {
        if (index === 0) {
          // 日期
          sums[index] = '合计';
          return;
        }
        if (index === 1) {
          // 来源
          sums[index] = '';
          return;
        }
        if (typeof idxMap[column.property] !== 'undefined') {
          idxMap[column.property] = index;
        }
        var values = data.map(function (item) {
          return +item[column.property];
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (percentKeys.includes(column.property)) {
            sums[index] = sums[index].toFixed(2) + '%';
          } else if (amountKeys.includes(column.property)) {
            sums[index] = '¥' + sums[index].toFixed(2);
          }
        } else {
          sums[index] = '--';
        }
      });
      // sums[idxMap.orderRate] = sums[idxMap.uv] ? (sums[idxMap.orderCount] / sums[idxMap.uv] * 100).toFixed(2) + '%' : '--'
      // sums[idxMap.payRate] = sums[idxMap.orderCount] ? (sums[idxMap.paidOrderCount] / sums[idxMap.orderCount] * 100).toFixed(2) + '%' : '--'

      return sums;
    }
  }
};